/**
 * Rolling Hills Chocolate — Theme behaviours
 * Header/footer markup now lives in layout/theme.liquid.
 * This file only wires up interactivity.
 */
(function () {
  const nav = document.getElementById('site-nav');

  /* ── SCROLL NAV SHADOW ── */
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.boxShadow = window.scrollY > 40 ? '0 2px 28px rgba(30,13,4,0.12)' : 'none';
    });
  }

  /* ── DROPDOWN: close when clicking outside ── */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.has-dropdown')) {
      document.querySelectorAll('.has-dropdown').forEach(d => d.classList.remove('dropdown-open'));
    }
  });
  document.querySelectorAll('.has-dropdown > a, .has-dropdown > button').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const li = trigger.closest('.has-dropdown');
      const wasOpen = li.classList.contains('dropdown-open');
      document.querySelectorAll('.has-dropdown').forEach(d => d.classList.remove('dropdown-open'));
      if (!wasOpen) li.classList.add('dropdown-open');
    });
  });

  /* ── MOBILE MENU ── */
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const closeBtn = document.getElementById('mobile-menu-close');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => mobileMenu.classList.add('open'));
    if (closeBtn) closeBtn.addEventListener('click', () => mobileMenu.classList.remove('open'));
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileMenu.classList.remove('open')));
  }

  /* ── ADD TO CART (demo button animation; real cart count comes from Shopify) ── */
  window.addToCart = function (btn) {
    const orig = btn.innerHTML;
    btn.textContent = 'Added!';
    btn.style.background = '#6b3015';
    const count = document.getElementById('cart-count');
    if (count) count.textContent = (parseInt(count.textContent || '0') + 1);
    setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; }, 2000);
  };

  /* ── PRODUCT IMAGE SLIDERS ── */
  window.initProductSliders = function () {
    document.querySelectorAll('.product-slider[data-slider]').forEach(slider => {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = '1';

      const track = slider.querySelector('.product-slides');
      const imgs = track ? track.querySelectorAll('img') : [];
      const dotsWrap = slider.querySelector('.slider-dots');
      const prev = slider.querySelector('.slider-arrow.prev');
      const next = slider.querySelector('.slider-arrow.next');
      if (!track || imgs.length === 0) return;

      let index = 0;

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        imgs.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
          dot.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); go(i); });
          dotsWrap.appendChild(dot);
        });
      }

      const dots = dotsWrap ? dotsWrap.querySelectorAll('.slider-dot') : [];

      function go(i) {
        index = (i + imgs.length) % imgs.length;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach((d, di) => d.classList.toggle('active', di === index));
      }

      if (imgs.length < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        if (dotsWrap) dotsWrap.style.display = 'none';
        return;
      }

      if (prev) prev.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); go(index - 1); });
      if (next) next.addEventListener('click', e => { e.stopPropagation(); e.preventDefault(); go(index + 1); });

      let startX = null;
      slider.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', e => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      });
    });
  };
  window.initProductSliders();

  /* ── READ MORE ── */
  window.initReadMore = function () {
    document.querySelectorAll('.product-desc').forEach(desc => {
      const link = desc.nextElementSibling;
      if (!link || !link.classList.contains('read-more')) return;
      if (desc.scrollHeight - desc.clientHeight > 1) link.style.display = 'inline-block';
    });
  };
  window.initReadMore();
  window.addEventListener('load', window.initReadMore);

  /* ── CLICKABLE PRODUCT CARDS ── */
  document.querySelectorAll('[data-href]').forEach(card => {
    card.style.cursor = 'pointer';
    card.addEventListener('click', e => {
      if (e.target.closest('.add-cart-btn, .slider-arrow, .slider-dot, a, button')) return;
      window.location.href = card.dataset.href;
    });
  });

  /* ── ENTRANCE ANIMATIONS ── */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });

  window.observeAnimations = function () {
    document.querySelectorAll('.product-card, .diff-card, .process-step, .highlight-row, .store-region, .anim').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      observer.observe(el);
    });
  };
  window.addEventListener('load', window.observeAnimations);
})();
